import FilterChipsContainer from "../FilterChipsContainer"
import { useState, useEffect, useRef } from "react"
import Sheet from 'react-modal-sheet';
import UserRepository from "../../../repository/UserRepository";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function ExploreUserInterestModal(
    { isUserInterestModalOpen, onUserInterestModalDismiss }
) {
    const footerRef = useRef(null)
    const [enabledFilters, setEnabledFilters] = useState([])
    const [loadingText, setLoadingText] = useState(null)
    const filters = {
        "nonFood": [
            {
            "tag": "art_creativity",
            "cleanLabel": "Art & Creativity",
            "displayLabel": "🎨 Art & Creativity"
            },
            {
            "tag": "date_night",
            "cleanLabel": "Date Night",
            "displayLabel": "💕 Date Night"
            },
            {
            "tag": "dog_friendly",
            "cleanLabel": "Dog Friendly",
            "displayLabel": "🐶 Dog Friendly"
            },
            {
            "tag": "hidden_gems",
            "cleanLabel": "Hidden Gems",
            "displayLabel": "🔍 Hidden Gems"
            },
            {
            "tag": "historic_cultural",
            "cleanLabel": "Historic & Cultural",
            "displayLabel": "🏛️ Historic & Cultural"
            },
            {
            "tag": "kid_friendly",
            "cleanLabel": "Kid Friendly",
            "displayLabel": "👶🏻 Kid Friendly"
            },
            {
            "tag": "live_music",
            "cleanLabel": "Live Music & Entertainment",
            "displayLabel": "🎶 Live Music & Entertainment"
            },
            {
            "tag": "outdoor",
            "cleanLabel": "Outdoor",
            "displayLabel": "🌿 Outdoor"
            },
            {
            "tag": "scenic",
            "cleanLabel": "Scenic",
            "displayLabel": "🌅 Scenic"
            },
            {
            "tag": "shopping_markets",
            "cleanLabel": "Shopping & Markets",
            "displayLabel": "🛍️ Shopping & Markets"
            },
            {
            "tag": "wellness_relaxation",
            "cleanLabel": "Wellness & Relaxation",
            "displayLabel": "🧘 Wellness & Relaxation"
            }
        ],
        "food": [
            {
            "tag": "bakery",
            "cleanLabel": "Bakery",
            "displayLabel": "🥐 Bakery"
            },
            {
            "tag": "brunch_spots",
            "cleanLabel": "Brunch Spots",
            "displayLabel": "🍳 Brunch Spots"
            },
            {
            "tag": "cafe",
            "cleanLabel": "Cafe",
            "displayLabel": "☕ Cafe"
            },
            {
            "tag": "cheap_eats",
            "cleanLabel": "Cheap Eats",
            "displayLabel": "💰 Cheap Eats"
            },
            {
            "tag": "cocktails",
            "cleanLabel": "Cocktails",
            "displayLabel": "🍸 Cocktails"
            },
            {
            "tag": "craft_beer",
            "cleanLabel": "Craft Beer",
            "displayLabel": "🍻 Craft Beer"
            },
            {
            "tag": "date_night",
            "cleanLabel": "Date Night",
            "displayLabel": "💕 Date Night"
            },
            {
            "tag": "desserts",
            "cleanLabel": "Desserts",
            "displayLabel": "🍰 Desserts"
            },
            {
            "tag": "dog_friendly",
            "cleanLabel": "Dog Friendly",
            "displayLabel": "🐶 Dog Friendly"
            },
            {
            "tag": "fine_dining",
            "cleanLabel": "Fine Dining",
            "displayLabel": "🍽️ Fine Dining"
            },
            {
            "tag": "halal",
            "cleanLabel": "Halal",
            "displayLabel": "🕌 Halal"
            },
            {
            "tag": "healthy",
            "cleanLabel": "Healthy",
            "displayLabel": "🥗 Healthy"
            },
            {
            "tag": "kid_friendly",
            "cleanLabel": "Kid Friendly",
            "displayLabel": "👶🏻 Kid Friendly"
            },
            {
            "tag": "late_night",
            "cleanLabel": "Late-Night Bites",
            "displayLabel": "🌙 Late-Night Bites"
            },
            {
            "tag": "scenic",
            "cleanLabel": "Scenic",
            "displayLabel": "🌅 Scenic"
            },
            {
            "tag": "street_food",
            "cleanLabel": "Street Food",
            "displayLabel": "🌮 Street Food"
            },
            {
            "tag": "vegetarian",
            "cleanLabel": "Vegetarian",
            "displayLabel": "🥕 Vegetarian"
            }
        ]
    }

    function onFilterOptionToggled(clickedOption) {
        console.log(`filter option toggled ${JSON.stringify(clickedOption)}`)
        if (enabledFilters.includes(clickedOption.id)) {
            setEnabledFilters(enabledFilters.filter((option) => option != clickedOption.id))
        } else {
            setEnabledFilters(enabledFilters.concat([clickedOption.id]))
        }
    }

    async function onApplyClick() {
        setLoadingText("Applying ...")
        const userRepository = new UserRepository()
        await userRepository.updateUserInterests(enabledFilters)
        onUserInterestModalDismiss()
    }

    return <Sheet isOpen={isUserInterestModalOpen} onClose={() => {onUserInterestModalDismiss()}} onOpenEnd={() => {
    }} detent="content-height">
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
        <Sheet.Scroller draggableAt="both">
            <div className="p-0">
        <div className={`px-6`}>
         <div className="h-8"></div>
        {
            <div className="mb-4">
                <div className="text-lg">
                Tell us what makes your stomach sing so we don’t send you to a tofu temple when you’re craving tacos. 🎶🌮🙅‍♂️
                </div>
                <div className="pt-4">
                    <FilterChipsContainer 
                        key={"food"}
                        title={null}
                        filterOptions={filters["food"].map((filterOption) => {
                            return {
                                label: filterOption.displayLabel,
                                id: filterOption.tag,
                                isSelected: enabledFilters.includes(filterOption.tag)
                            }
                        })}
                        onFilterOptionClick={onFilterOptionToggled}
                        />
                </div>
            </div>
        }
        <div className="h-24"></div>
        </div>
        <div className="modal-action absolute bottom-0 right-0 bg-base-100 w-full px-6 py-4" ref={footerRef}>
            <button className="btn btn-success text-success-content mr-2" onClick={
                () => {
                    onApplyClick(enabledFilters)
                }
                } >Apply
            </button>
            <button className="btn btn-ghost" onClick={
                () => {
                    onUserInterestModalDismiss()
                }
                }>Close</button>
        </div>
        {loadingText &&
        <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
            <div className="loading loading-infinity loading-lg"></div>
            <div className='font-normal text-base-content mt-2'>{loadingText}</div>
        </div>
        }
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onUserInterestModalDismiss()
        }}/>
    </Sheet>
}